<template>
    <div class="image-reveal">
        <div class="image-reveal__placeholder"
            :style="'background-image: url(' + responsiveImage.placeholder + '); padding-top: ' + imageHeight + '%;'"
            aria-hidden="true"
            role="presentation">
        </div>
        <img class="image-reveal__image"
            :class="classObject"
            :src="imageForOldBrowsers"
            :srcSet="responsiveImage.srcSet"
            :sizes="imageSizes"
            :alt="imageAltText"
            @load="imageIsLoaded = true;">
    </div>
</template>

<script>
export default {
    props: {
        responsiveImage: Object,
        imageSizes: String,
        imageAltText: String,
    },
    data() {
        return {
            imageIsLoaded: false,
            imageLoadedSlowly: false,
        };
    },
    computed: {
        imageHeight() {
            return this.responsiveImage.height / this.responsiveImage.width * 100;
        },
        imageForOldBrowsers() {
            // The responsiveImage.images array's last item will be the images
            // largest size at 2x, if we halve this we will know the largest 1x
            // image size, which is the best option to show on older browsers.
            const imageSizesCount = this.responsiveImage.images.length;
            const largestImageSize = this.responsiveImage.images[imageSizesCount - 1].width;
            const largest1xImage = this.responsiveImage.images.find(x => x.width === largestImageSize / 2);

            return largest1xImage.path;
        },
        classObject() {
            return {
                'image-reveal__image--visible': this.imageIsVisible,
                'image-reveal__image--fade-in': this.imageShouldFadeIn,
            };
        },
        imageIsVisible() {
            // If the page is being prerendered dont add the visible class
            // otherwise it will always exist inline
            if (window.__PRERENDER_INJECTED
                && window.__PRERENDER_INJECTED.prerendered) {
                return false;
            }

            if (this.imageIsLoaded) {
                return true;
            }

            return false;
        },
        imageShouldFadeIn() {
            // If the page is being prerendered dont fade in otherwise the fade
            // in class will always exist inline
            if (window.__PRERENDER_INJECTED
                && window.__PRERENDER_INJECTED.prerendered) {
                return false;
            }

            // If the image has taken longer than 200ms to load, fade in
            if (this.imageLoadedSlowly) {
                return true;
            }

            return false;
        },
    },
    mounted() {
        setTimeout(() => {
            this.imageLoadedSlowly = true;
        }, 200);
    },
};
</script>

<style lang="scss">
.image-reveal {
    position: relative;
    overflow: hidden;
}

.image-reveal__placeholder {
    background-size: cover;
    filter: blur(25px);
}

.image-reveal__image {
    display: block;
    position: absolute;
    z-index: map-get($z-index, 'above');
    top: 0;
    width: 100%;
    opacity: 0;
    color: transparent;

    &.image-reveal__image--visible {
        opacity: 1;
    }

    &.image-reveal__image--fade-in {
        transition: opacity 0.3s ease-in;
    }

    // If JS is not running, just show the image normally
    .no-js & {
        opacity: 1;
    }
}
</style>
